export default {
    // User module common translations
    user_management: '用户管理',
    user_list: '用户列表',
    user_info: '用户信息',
    user_edit: '编辑用户',
    user_create: '创建用户',
    user_delete: '删除用户',
    user_search: '搜索用户',
    user_import: '导入用户',
    user_export: '导出用户',

    // Form fields and placeholders
    enter_name_phone: '请输入参会代表姓名/手机号',
    select_checkin_status: '请选择是否签到',
    all: '全部',
    checked_in: '已签到',
    not_checked_in: '未签到',

    // Table columns
    reg_no: '注册号',
    representative_name: '代表姓名',
    mobile: '手机号码',
    order_count: '订单数量',
    gender: '性别',
    organization: '所属单位',
    nationality: '国籍',
    region: '地区',
    email: '电子邮箱',
    reg_time: '注册时间',
    operation: '操作',

    // Actions
    add: '添加',
    import_user: '导入用户',
    export: '导出',
    search: '搜索',
    details: '详情',
    delete: '删除',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    submit_audit: '提交审核',
    // Messages
    tips: '提示',
    confirm_delete: '确定删除该用户吗？',
    save_success: '保存成功',
    delete_success: '删除成功',
    import_success: '导入成功',
    export_success: '导出成功',

    // User info component
    edit_profile: '编辑资料',
    basic_info: '基本资料',
    ticket_orders: '门票订单',
    hotel_orders: '酒店订单',
    travel_info: '行程信息',
    add_order: '新增订单',
    add_hotel_order: '新增酒店订单',

    // Order status
    order_no: '订单编号',
    goods_name: '商品名称',
    order_amount: '订单金额',
    payment_status: '支付状态',
    payment_method: '支付方式',
    refund_status: '退款状态',
    none: '暂无',

    // Payment and refund status
    pending_payment: '待支付',
    paid: '已支付',
    refund_completed: '退款完成',
    refunding: '退款中',
    refund_rejected: '拒绝退款',
    not_refunded: '未退款',

    // Review status
    pending_review: '待审核',
    approved: '已通过',
    rejected: '未通过',
    no_review_needed: '不需要审核',
    audit_btn_text: '审核',
    audit_status_title: '审核状态',
    select_audit_status: '请选择审核状态',
    audit_error: '驳回',
    audit_success: '通过',
    audit_remark: '审核备注',
    audit_remark_p: '请输入审核备注',
    // Form fields
    username: '用户名',
    password: '密码',
    phone: '手机号',
    status: '状态',
    create_time: '创建时间',
    update_time: '更新时间',

    // Status
    status_active: '启用',
    status_inactive: '禁用',

    // Validation messages
    required_field: '此字段为必填项',
    invalid_email: '请输入有效的邮箱地址',
    invalid_phone: '请输入有效的手机号',

    // User edit component
    add_user: '添加用户',
    search_user: '查询用户',
    search_user_tip: '请在添加新用户前，先通过搜索查询用户信息是否存在。',
    enter_name: '请输入用户姓名',
    enter_mobile: '请输入手机号',
    enter_company: '请输入工作单位',
    add_new_user: '添加新用户',
    add_success: '添加成功',
    chinese_guest: '中宾',
    foreign_guest: '外宾',

    // Add order component
    description: '描述',
    discount_info: '优惠信息',
    to: '至',
    add_success: '添加成功',
    create_hotel_order: '创建酒店订单',
    create_success: '创建成功',

    // Create order component
    create_order: '创建订单',
    user_id: '用户ID',
    channel: '渠道',
    select_channel: '请选择渠道',
    goods: '商品',
    select_goods: '请选择商品',
    select_payment: '请选择支付方式',
    select_payment_status: '请选择支付状态',

    // Edit order component
    edit_order: '编辑订单',
    order_id: '订单ID',
    upload_file: '上传文件',
    view: '查看',
    operation_success: '操作成功',
    upload_doc_image: '只能上传doc、docx格式 和 图片',
    file_size_limit: '文件大小不能超过3M',

    // Identity edit component
    edit_config: '编辑配置',
    add_config: '添加配置',
    config_info: '配置信息',
    config_tip: '配置应用中，对其停用方可编辑配置。',
    config_id: '配置ID',
    enter_config_id: '请输入配置ID',
    identity_type: '身份类型名称',
    enter_identity_type: '请输入身份类型名称',
    verify_method: '验证方式',
    select_verify_method: '请选择验证方式',
    api_verify: '接口验证',
    manual_verify: '人工验证',
    verify_url: '接口验证地址',
    enter_verify_url: '请输入接口验证地址',

    // Import modal component
    import: '导入',
    data_validation: '数据校验',
    select_validation_type: '请选择数据校验类型',
    validate_data: '校验数据真实性',
    no_validate_data: '不校验数据真实性',
    upload_data: '上传数据',
    upload_file: '上传文件',
    clear: '清除',
    download_template: '下载模板',
    error_tip: '错误提示',
    only_excel: '仅支持上传Excel文件',
    upload_valid_excel: '请上传有效的Excel文件',

    // Import data table columns
    import_name: '导入数据-姓名',
    import_mobile: '导入数据-手机',
    import_email: '导入数据-邮箱',
    import_org: '导入数据-单位',
    system_name: '系统数据-姓名',
    system_mobile: '系统数据-手机',
    system_email: '系统数据-邮箱',
    system_org: '系统数据-单位',

    // Route info component
    arrival_info: '来程信息',
    departure_info: '返程信息',
    accommodation_info: '住宿信息',
    departure_time: '出发时间',
    arrival_time: '到达时间',
    transport_type: '交通方式',
    flight_number: '航班/车次',
    departure_city: '出发地',
    destination: '目的地',
    hotel_name: '酒店名称',
    room_type: '房间类型',
    room_name: '房型名称',
    check_in_time: '入住时间',
    check_out_time: '离店时间',
    no_data: '暂无数据',

    // User form component
    name: '姓名',
    enter_name: '请输入姓名',
    mobile_number: '手机号码',
    enter_mobile: '请输入手机号码',
    invalid_mobile: '手机号格式不正确',
    nationality: '国籍',
    gender: '性别',
    select_gender: '请选择性别',
    male: '男',
    female: '女',
    email: '电子邮箱',
    enter_email: '请输入电子邮箱',
    invalid_email: '邮箱格式不正确',
    organization: '所属单位',
    enter_organization: '请输入所属单位',
    avatar: '头像',
    upload_avatar: '请上传头像',
    upload_image: '上传图片',
    image_only: '您只能上传图像文件',
    mobile_exists: '该手机号码已存在',
    region: '所属地区',
    profile: '个人简介',
    enter_profile: '请输入个人简介',

    // VIP module specific translations
    vip_management: 'VIP管理',
    vip_list: 'VIP列表',
    vip_info: 'VIP信息',
    vip_edit: '编辑VIP',
    vip_create: '创建VIP',
    vip_delete: '删除VIP',
    vip_search: '搜索VIP',
    vip_import: '导入VIP',
    vip_export: '导出VIP',
    vip_details: 'VIP详情',
    vip_status: 'VIP状态',
    vip_level: 'VIP等级',
    vip_points: 'VIP积分',
    vip_expiry_date: 'VIP到期时间',
    vip_benefits: 'VIP权益',
    vip_notes: 'VIP备注',

    // Identity module specific translations
    identity_verification_desc: '身份验证：门户平台对用户在指定学会或组织内的身份进行验证的过程。',
    application_status: '应用状态',
    status_disabled: '已停用',
    status_enabled: '应用中',
    disable: '停用',
    enable: '应用',
    confirm_delete_identity: '确定删除该身份类型吗？',
    index: '序号',

    identity_name: '身份名称',
    treatment_name: '待遇名称',
    cn_tips: '中宾提示语',
    en_tips: '外宾提示语',
    p_cn_tips: '请输入中宾提示语',
    p_en_tips: '请输入外宾提示语',

    is_vip: '是否是vip',
    p_is_vip: '请选择用户是否是vip'
};
